import { Link, useLocation, useNavigate } from "react-router-dom";
import Layout from "../include/layout";
import { myroutes } from "../../routes/webroute";
import { Button, Col, Form, Row } from "react-bootstrap";
import { useEffect, useState } from "react";
import Swal from "sweetalert2";
import $ from "jquery"
import RolesService from "../../services/RolesService";
import UsersService from "../../services/UsersService";
import Select from "react-select";
import makeAnimated from 'react-select/animated';
import { useSelector } from "react-redux";


export default function ProfilEdit(){
   
     //##########################/// METHODES ##########################///
    //navigate pour faire les redirections
    const navigate = useNavigate()
    const [validationError, setValidationError] = useState({})
    const location = useLocation()
    const token = useSelector(state => state.auth.token)

    const animatedComponents = makeAnimated()
	const auth = useSelector(state => state.auth)

    //Creation des ascesseurs getters et setters pour tout le formulaire
    const [nom, setNom] = useState('')
    const [prenoms, setPrenoms] = useState('')
    const [adresse, setAdresse] = useState('')
    const [telephone, setTelephone] = useState('')
    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    const [conf_password, setConfPassword] = useState('')

    const [roles, setRoles] = useState([]); //Liste des roles disponible
    const [selectedRoles, setSelectedRoles] = useState([]);
    //const [defaultRoles, setDefaultRoles] = useState([]);

    ///Save form data
    const handleSubmit = async (event) => {
        event.preventDefault()
        //Recupérer uniquement les id
        var roles = selectedRoles.map((option) => option.value)
        let form = {
            nom, prenoms, adresse, telephone, email, password, conf_password, roles,
        }
        //Si state.id == null utiliser l'id du user connecté
        await UsersService.update(location.state ? location.state.id : auth.user.id, form,token).then((response) => {
            if (response.data.erreur) {
                Swal.fire({
                    icon: "error",
                    text: response.data.erreur,
                    showConfirmButton: false,
                    timer: 2000
                })
                setValidationError(response.data.erreur)
            } else {
                //redirection sur index
                navigate(myroutes.users_index)
                Swal.fire({
                    icon: "success",
                    text: response.data.message,
                    toast: true,
                    position: 'top-right',
                    showConfirmButton: false,
                    timer: 2000,
                    timerProgressBar: true,
                    background: "green",
                    iconColor: "white",
                    color: "white"
                })
            }
        }).catch(error => {
            Swal.fire({
                icon: "error",
                text: error.message
            })
            //affichage des erreurs sur le formulaire
            setValidationError(error.message)
        });
    }

    const handleRoleSelection = (selectedOptions) => {
        setSelectedRoles(selectedOptions);
    };

    const getRoles = async () => {
        await RolesService.index(token).then((response) => {
            setRoles(response.data.roles)
        }).catch(error => {
            console.log(error.message)
        });
    }

    ///Créer une constante pour afficher les valeurs du select
    const roleOptions = roles.map((role) => ({
        value: role.id,
        label: role.libelle
    }));


    useEffect(() => {
        //get edit data
        const edit = async () => {
            await UsersService.edit(auth.user.id,token).then((response) => {
                const data = response.data.user
                setNom(data.nom)
                setPrenoms(data.prenoms)
                setAdresse(data.adresse)
                setEmail(data.email)
                setTelephone(data.telephone)
                //console.log(response.data.userRoles)
                //setDefaultRoles(response.data.user_roles)

                /*const roleOptionsDefault = defaultRoles.map((defaultRole) => ({
                    value: defaultRole.id,
                    label: defaultRole.libelle,
                }))*/
                setSelectedRoles(response.data.user_roles.map((defaultRole) => ({
                    value: defaultRole.id,
                    label: defaultRole.libelle,
                })))

            }).catch(error => {
                Swal.fire({
                    icon: "error",
                    text: error.message
                })
                setValidationError(error.message)
            });
        }
        edit();
        getRoles();
        $("#submenu-4").addClass("show")
    }, [])

    //##########################/// END METHODES ##########################///

    return (
        <Layout>
            <div className="app-content pt-3 p-md-3 p-lg-4 app-card app-card-stat">
                <div className="container-xl app-card-body">

                    <div className="row g-3 align-items-center justify-content-between">
                        <div className="col-auto">
                            <div className="pagetitle">
                                <h1 className="app-page-title mb-0 text-start">Administration</h1>
                                <nav>
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item"><Link to={myroutes.dashboard} >Accueil</Link></li>
                                        <li className="breadcrumb-item"><Link to={myroutes.users_index} >Utilisateurs</Link></li>
                                        <li className="breadcrumb-item active">Modification utilisateur </li>
                                    </ol>
                                </nav>
                            </div>
                        </div>
                    </div>{/*//row*/}

                    <div className="row g-3 mb-4 align-items-center justify-content-between">
                        <div className="col-auto">
                            <h1 className="app-page-title mb-0">Modification </h1>
                        </div>
                    </div>{/*//row*/}

                    <div className="app-card app-card-settings shadow-lg mb-5">
                        <div className="app-card-body py-2 mx-3">
                            <Row>
                                {
                                    Object.keys(validationError).length > 0 && (
                                        <div className="row">
                                            <div className="col-12">
                                                <div className="alert alert-danger">
                                                    <ul className="mb-0">
                                                        {
                                                            <li>{validationError}</li>
                                                        }
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                }
                            </Row>
                            <Form className="mx-3 settings-form" style={{ textAlign: "left" }} onSubmit={handleSubmit}>

                                <Row>
                                    <Col md={6} sm={12} className="form-group">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Nom <i className="text-danger">*</i>
                                            </Form.Label>
                                            <Form.Control className="border border-info border rounded-2" onChange={(e) => setNom(e.target.value)}
                                                value={nom}
                                                placeholder="Votre nom"
                                                name="nom"
                                                aria-label="nom"
                                                maxLength={100}
                                                minLength={3}
                                                type="text"
                                                required
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={6} sm={12} className="form-group">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Prénoms <i className="text-danger">*</i>
                                            </Form.Label>
                                            <Form.Control className="border border-info border rounded-2" onChange={(e) => setPrenoms(e.target.value)}
                                                value={prenoms}
                                                placeholder="Votre prénom"
                                                name="prenom"
                                                aria-label="prenom"
                                                maxLength={100}
                                                minLength={3}
                                                type="text"
                                                required
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={6} sm={12} className="form-group">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Téléphone <i className="text-danger"></i>
                                            </Form.Label>
                                            <Form.Control className="border border-info border rounded-2" onChange={(e) => setTelephone(e.target.value)}
                                                value={telephone}
                                                placeholder=""
                                                name="telephone"
                                                aria-label="telephone"
                                                maxLength={15}
                                                minLength={8}
                                                type="text"
                                                required
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={6} sm={12} className="form-group">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Email <i className="text-danger">*</i>
                                            </Form.Label>
                                            <Form.Control className="border border-info border rounded-2" onChange={(e) => setEmail(e.target.value)}
                                                value={email}
                                                placeholder=""
                                                name="email"
                                                aria-label="email"
                                                maxLength={100}
                                                minLength={5}
                                                type="email"
                                                required
                                            />
                                        </Form.Group>
                                    </Col>

                                </Row>
                                <Row>
                                    <Col md={6} sm={12} className="form-group">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Adresse <i className="text-danger"></i>
                                            </Form.Label>
                                            <Form.Control className="border border-info border rounded-2" onChange={(e) => setAdresse(e.target.value)}
                                                value={adresse}
                                                placeholder=""
                                                name="adresse"
                                                aria-label="adresse"
                                                maxLength={100}
                                                type="text"
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={6} sm={12} className="form-group">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Roles <i className="text-danger">*</i> </Form.Label>
                                            <Select
                                                options={roleOptions}
                                                isMulti
                                                onChange={handleRoleSelection}
                                                components={animatedComponents}
                                                value={selectedRoles}
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={6} sm={12} className="form-group" >
                                        <Form.Group className="mb-3">
                                            <Form.Label>Mot de passe <i className="text-danger">*</i></Form.Label>
                                            <Form.Control className="border border-info border rounded-2" onChange={(e) => setPassword(e.target.value)}
                                                value={password}
                                                placeholder="Mot de passe "
                                                name="password"
                                                aria-label="password"
                                                maxLength={100}
                                                minLength={8}
                                                type="password"
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={6} sm={12} className="form-group" >
                                        <Form.Group className="mb-3">
                                            <Form.Label>Confirmer Mot de passe <i className="text-danger">*</i></Form.Label>
                                            <Form.Control className="border border-info border rounded-2" onChange={(e) => setConfPassword(e.target.value)}
                                                value={conf_password}
                                                placeholder="Confirmer Mot de passe "
                                                name="conf_password"
                                                aria-label="conf_password"
                                                maxLength={100}
                                                minLength={8}
                                                type="password"
                                            />
                                        </Form.Group>
                                    </Col>

                                </Row>


                                <Button type="submit" variant="primary">Enregistrer</Button>
                            </Form>

                        </div>{/*//app-card-body*/}
                    </div>
                    {/*//app-card*/}

                </div>{/*//container-fluid*/}
            </div>{/*//app-content*/}
        </Layout>
    )
}